// ABOUTME: Reusable dialog showing a shareable URL with a copy button and QR code.
// ABOUTME: Used wherever a share link needs to be presented to the user.
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import QRCode from 'react-qr-code'
import { ShareLinkUrl } from '../theme'

interface ShareLinkDialogProps {
  open: boolean
  onClose: () => void
  url: string
  title: string
  description?: string
  onCopy?: () => void
}

export function ShareLinkDialog({ open, onClose, url, title, description, onCopy }: ShareLinkDialogProps) {
  function handleCopy() {
    navigator.clipboard.writeText(url)
    onCopy?.()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {description && (
          <Typography variant="body2" gutterBottom>
            {description}
          </Typography>
        )}
        <Stack direction="row" spacing={1} alignItems="center" mb={3}>
          <ShareLinkUrl variant="body2" component="code">
            {url}
          </ShareLinkUrl>
          <Button
            variant="outlined"
            size="small"
            onClick={handleCopy}
          >
            Copy
          </Button>
        </Stack>
        <Box display="flex" justifyContent="center">
          <QRCode value={url} size={200} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
